export enum FeatureLabel {
	ANALYTICS_VIEWER = 'Analytics Viewer',
	ARTISTS_EDITOR = 'Artists Editor',
	CHARTS_VIEWER = 'Charts Viewer',
	PLAYLISTS_REPORT = 'Playlists Report Viewer',
	USERS_EDITOR = 'Users Editor',
	DELIVERY_MONITORING_VIEWER = 'Delivery Monitoring Viewer',
	PITCHING_TOOL = 'Pitching Tool Editor',
	CAMPAIGN_MANAGER = 'Campaign Manager Editor',
	COPYRIGHT_CLAIM = 'Copyright Claim Manager Editor',
	BETA = 'Beta',
}

export type Feature = {
	label: FeatureLabel;
	enabled: boolean;
	isHidden?: boolean;
};
